export enum InputType {
  FLOAT_NUMBER = "float_number",
  INT_NUMBER = "int_number",
  CHARS = "text",
}
